import { useUrlEditorSelection } from '../../../hooks/useUrlEditorSelection.tsx';
import DeckPlanDetails from '../components/DeckPlanDetails.tsx';
import { DECK_PLAN_SELECTED_PARAM } from '../utils/deckPlanUrlParams.ts';
import type { DeckPlan } from '../types/deckPlanTypes.ts';

interface UrlSelectionParams {
  allData: DeckPlan[] | null;
  dataForTable: DeckPlan[];
  rowsPerPage: number;
  setPage: (page: number) => void;
  /** List refetch, forwarded into `DeckPlanDetails` so a save can refresh the row. */
  refetch?: () => Promise<void>;
}

/**
 * DeckPlan binding for the generic {@link useUrlEditorSelection} hook:
 * param key `selected`, id is the full NeTEx id, editor is
 * `<DeckPlanDetails>`. `getEmptyRow` powers the create flow when
 * `?selected=new` is opened from the New Deck Plan action.
 */
export function useDeckPlanUrlSelection({
  allData,
  dataForTable,
  rowsPerPage,
  setPage,
  refetch,
}: UrlSelectionParams): void {
  useUrlEditorSelection<DeckPlan>({
    paramKey: DECK_PLAN_SELECTED_PARAM,
    allData,
    dataForTable,
    rowsPerPage,
    setPage,
    getId: dp => dp.id,
    renderEditor: host => <DeckPlanDetails {...host} onSaved={refetch} />,
  });
}
